"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPurposes = exports.ConsentCategory = void 0;
var ConsentCategory;
(function (ConsentCategory) {
    ConsentCategory["CMP_ANALYTICS"] = "CMP_ANALYTICS";
    ConsentCategory["CMP_MARKETING"] = "CMP_MARKETING";
    ConsentCategory["CMP_ADVERTISING"] = "CMP_ADVERTISING";
    ConsentCategory["CMP_PERSONALIZATION"] = "CMP_PERSONALIZATION";
})(ConsentCategory = exports.ConsentCategory || (exports.ConsentCategory = {}));
exports.defaultPurposes = (_a = {},
    _a[ConsentCategory.CMP_ANALYTICS] = {
        optIn: false
    },
    _a[ConsentCategory.CMP_MARKETING] = {
        optIn: false
    },
    _a[ConsentCategory.CMP_ADVERTISING] = {
        optIn: false
    },
    _a[ConsentCategory.CMP_PERSONALIZATION] = {
        optIn: false
    },
    _a);
function consents(input) {
    var _a;
    var consentsInput = (input || {}).consents;
    if (!consentsInput) {
        return undefined;
    }
    var purposesInput = (_a = consentsInput === null || consentsInput === void 0 ? void 0 : consentsInput.purposes) !== null && _a !== void 0 ? _a : {};
    return {
        purposes: purposes(purposesInput)
    };
}
exports.default = consents;
function purposes(purposesInput) {
    var purposes = __assign({}, exports.defaultPurposes);
    for (var category in purposesInput) {
        var consentCategory = category;
        var isValidCategory = Boolean(exports.defaultPurposes[consentCategory]);
        var isValidPurposeId = validatePurposeId(purposesInput[consentCategory]);
        if (isValidCategory && isValidPurposeId) {
            purposes[consentCategory] = toConsentPurposeCategory(purposesInput[consentCategory]);
        }
    }
    return purposes;
}
function validatePurposeId(purposeId) {
    return (purposeId && purposeId !== '');
}
function toConsentPurposeCategory(purposeId) {
    return {
        '@id': purposeId,
        optIn: true
    };
}
